import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import { browserHistory } from '../services/history'

// LAZY CHUNKS (25 Oct 2026). gwmc.js has a 250 KB gzipped budget
// (bin/check-bundle-size), so what most visitors never open is its own
// script, fetched when it is needed: the home page's challenger fold
// (hero-reg.js) and the two legal pages (legal.js). Each chunk is built with
// gwmc.js's React and Helmet handed over on window.__gwmcHost
// (esbuild.config.mjs, lib/host/*), and puts what it exports on
// window.__gwmcChunks. Where each one is comes from the server (asset_path):
// the gwmc:chunks meta tag, or the caller's own `src`.
const loading = {}

export const chunkSrc = name => {
  try {
    return JSON.parse(document.querySelector("meta[name='gwmc:chunks']").getAttribute('content'))[name] || null
  } catch (e) {
    return null
  }
}

export const chunkExport = name => (typeof window !== 'undefined' && window.__gwmcChunks && window.__gwmcChunks[name]) || null

// Resolves with the named export once the script has run.
export const loadChunk = (src, name, extra) => {
  window.__gwmcHost = { ...window.__gwmcHost, React, Helmet, history: browserHistory, ...extra }
  loading[src] = loading[src] || new Promise((resolve, reject) => {
    const s = document.createElement('script')
    s.src = src
    s.onload = resolve
    s.onerror = reject
    document.head.appendChild(s)
  })
  return loading[src].then(() => chunkExport(name) || Promise.reject(new Error(name)))
}

// A route whose page is in a chunk. Nothing until it arrives; a sentence if
// it never does.
export const ChunkPage = ({ chunk, page }) => {
  const [Page, setPage] = useState(() => chunkExport(page))
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    if (!Page) loadChunk(chunkSrc(chunk), page).then(p => setPage(() => p), () => setFailed(true))
  }, [])
  if (Page) return <Page />
  return <div className="gwmc-section">{failed ? 'This page did not load. Please refresh to try again.' : null}</div>
}
